export const calculateServerIndexFromAvailableServers = ({
  valueToHash,
  availableServers,
}: {
  valueToHash: string;
  availableServers: number;
}): number => {
  if (availableServers <= 0) {
    return 0;
  }

  let hash = 0;
  const prime = 31;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < valueToHash.length; i++) {
    const charCode = valueToHash.charCodeAt(i);
    hash = (hash * prime + charCode) % Number.MAX_SAFE_INTEGER;
  }

  const serverIndex = Math.abs(hash) % availableServers;

  return serverIndex;
};
